<template>
  <b-modal :id="id" centered size="lg">
    <div v-if="$i18n.locale === 'tw'">
      <h5>《經書法寶寄贈服務暫停公告》</h5>
      2026年2月12日(週四)至2月22日(週日)為大掃除日期及農曆春節假期，<br>
      本會經書法寶寄贈服務暫停11天，<br>
      煩請儘量於春節假期後，再申請經書法寶，<br>
      造成不便之處，敬祈包涵見諒！<br>
      耑此 敬祝<br>
      春節吉祥如意！闔家平安康寧！
    </div>
    <div v-else-if="$i18n.locale === 'en'">
      NOTICE:<br>
      Dear Ven. Friends in Dharma<br>
      Namo Amitabha!<br>
      On the Chinese New Year vacation: 12 February, 2026 ~ 22 February, 2026,<br>
      we are not able to offer the service of sending Dharma books,<br>
      please kindly apply for Dharma books after the vacation, avoiding that it will take more time for you to receive the Dharma books.<br><br>
      Thanks very much for your kind understanding and cooperation in advance!<br>
      With Metta & warm regards we remain<br>
      Yours in the Dharma<br><br>
      The Corporate Body of the Buddha Educational Foundation
    </div>
    <template #modal-footer="{ close }">
      <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import { ModalPlugin } from 'bootstrap-vue'
import i18n from '@/plugins/i18n.js'

Vue.use(ModalPlugin)

export default {
  i18n,
  name: 'dharma-grant-susp-msg-modal',
  props: {
    id: {
      type: String,
      required: true
    }
  }
}
</script>
